import React from 'react';
import Button from '../../../buttons/Button';
import { ISideButton } from './interface';

function SideButton(props: ISideButton) {
  return (
    <Button.Default
      onClick={props.onClick}
      wasClicked={props.wasClicked}
      justifyContent="space-between"
      width="10rem"
      margin="5px 0"
      height="2.75rem">
      {props.children}
    </Button.Default>
  );
}

export default SideButton;
